// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 568px) {\n.buttons-wrapper[data-v-53ed2716] {\n    width: 100%;\n    text-align: center;\n}\n}\n", ""]);
// Exports
module.exports = exports;
